export default "__VITE_ASSET__d195b7fc__"